var path = '/var/www/mmscny-website/src/app/common/components/display-cover-pic/display-cover-pic.html';
var html = "<div class=image-div> <img alt={{$ctrl.alternativeText}} ng-image-load={{$ctrl.coverPicUrl}} default-image-key=coverPic class=img-responsive /> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/display-cover-pic/display-cover-pic.html
// module id = 645
// module chunks = 0